import React from 'react';

const SendIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.75 2.8125V10.6875" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M3.93701 5.62459L6.75007 2.81152L9.56314 5.62459"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SendIcon;
